import { datadogRum } from '@datadog/browser-rum';
  

  const InitializeDatadogRum = () => {
    if(process.env.REACT_APP_DD_APP_ID && process.env.REACT_APP_DD_CLIENT_TOKEN){
        datadogRum.init({
            applicationId: process.env.REACT_APP_DD_APP_ID,
            clientToken: process.env.REACT_APP_DD_CLIENT_TOKEN,
            site: 'us5.datadoghq.com',
            service:'launch',
            env: process.env.REACT_APP_ENV,
            version: process.env.REACT_APP_COMMIT_ID,
            sessionSampleRate: 100,
            sessionReplaySampleRate: 100,
            trackUserInteractions: true,
            trackResources: true,
            trackLongTasks: true,
            defaultPrivacyLevel:'mask-user-input',
            enableExperimentalFeatures: ['clickmap'],
            allowedTracingUrls: ["https://launch.aviatrix.com", "https://api.launch.aviatrix.com", /^https:\/\/.*\.aviatrix\.com$/, (url) => {
              try {
                  const urlHost = new URL(url).host;
                  return ["launch.aviatrix.com", "api.launch.aviatrix.com"].includes(urlHost);
              } catch (e) {
                  return false;
              }
            }]
        });
    }
  }

  declare global {
    interface Window {
      DatadogRumSetUser:(category:string,action:string,label:string) => void;
    }
  }
  
  (window as any).DatadogRumSetUser = (email:string) => {
    if(datadogRum){
        datadogRum.setUser({
            email: email
        })
    }
  }
  

  
export default InitializeDatadogRum
